module.exports = __webpack_public_path__ + "img/pumping-activities-word1.72a46a05.png";